import { Pipe, PipeTransform, inject } from '@angular/core';
import { UtilsService } from './utils.service';

@Pipe({
  standalone: true,
  name: 'jsonValueByKey',
})
export class JsonValueByKeyPipe implements PipeTransform {
  utilsService = inject(UtilsService);

  transform(value: string, jsonKey: string = undefined): any {
    if (!value) return null;
    try {
      if (jsonKey) {
        const jsonString = this.utilsService.cleanJsonString(value);
        return JSON.parse(jsonString)[jsonKey];
      }
    } catch (e) {
      return null;
    }
  }
}
